import { Component, OnInit } from "@angular/core";
import * as moment from "moment";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { ReportService } from "../report.service";

@Component({
	selector: "app-access-scanning",
	templateUrl: "./access-scanning.component.html",
	styleUrls: ["./access-scanning.component.css"],
})
export class AccessScanningComponent implements OnInit {
	constructor(
		private userService: UserService,
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		private dialogService: DialogService
	) {}
	report = {
		//Insert Custom Parameters Here
		SchoolID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
		GradeLevelID: -1,
		AcademyID: -1,
		HomeroomID: -1,
		GroupID: -1,
		Active: 1,
		ScanAccessResultID: -1,
		ScanAccessModeID: -1,
		SortBy: "FirstName",
		SortDirection: "ASC",
		ImageLogo: "",
		ShowDetailID: "Yes",
	};

	//Insert Custom Lists Here
	ActiveOptionList: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];
	GradeLevelList: any = [];
	AcademyList: any = [];
	HomeroomList: any = [];
	GroupList: any = [];
	ScanAccessResultList: any = [];
	ScanAccessModeList: any = [];

	SortByList: any = [
		{
			ID: "FirstName",
			Desc: "First Name",
		},
		{
			ID: "LastName",
			Desc: "Last Name",
		},
		{
			ID: "StudentID",
			Desc: "Student ID",
		},
		{
			ID: "School",
			Desc: "School",
		},
		{
			ID: "GradeLevel",
			Desc: "Grade Level",
		},
		{
			ID: "Homeroom",
			Desc: "Homeroom",
		},
		{
			ID: "Academy",
			Desc: "Academy",
		},
		{
			ID: "ScanDT",
			Desc: "Scan Date",
		},
		{
			ID: "ScanMode",
			Desc: "Scan Mode",
		},
		{
			ID: "ScanResult",
			Desc: "Scan Result",
		},
	];
	SortDirectionList: any = [
		{
			ID: "ASC",
			Desc: "Ascending",
		},
		{
			ID: "DESC",
			Desc: "Descending",
		},
	];
	ImageLogoList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	ReportID: number = 480;

	subscription: any;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ngOnInit() {
		//Insert Custom Init Methods Here
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});

		this.loadScanAccessResult();
		this.loadScanAccessMode();
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadGradeLevel();
		this.loadAcademy();
		this.loadHomeroom();
		this.loadGroup();
		this.loadLogolist();
	}

	private loadGradeLevel() {
		this.report.GradeLevelID = 0;
		var result = this.reportService.GradesGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GradeLevelList = response;

				if (this.GradeLevelList.length > 1) {
					// this.GradeLevelList.unshift({
					//     GradeLevelID: 0,
					//     GradeLevelDesc: "All Grades"
					// })
					this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
				} else {
					this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
				}
			},
			(error) => {}
		);
	}

	private loadAcademy() {
		this.report.AcademyID = 0;
		var result = this.reportService.AcademyGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.AcademyList = response;

				if (this.AcademyList.length > 1) {
					// this.AcademyList.unshift({
					//     AcademyID: 0,
					//     AcademyDesc: "All Academies"
					// })
					this.report.AcademyID = this.AcademyList[0].AcademyID;
				} else {
					this.report.AcademyID = this.AcademyList[0].AcademyID;
				}
			},
			(error) => {}
		);
	}

	private loadHomeroom() {
		this.report.HomeroomID = 0;
		var result = this.reportService.HomeroomGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.HomeroomList = response;

				if (this.HomeroomList.length > 1) {
					// this.HomeroomList.unshift({
					//     HomeroomID: 0,
					//     Homeroom: "All Homerooms"
					// })
					this.report.HomeroomID = this.HomeroomList[0].HomeroomID;
				} else {
					this.report.HomeroomID = this.HomeroomList[0].HomeroomID;
				}
			},
			(error) => {}
		);
	}

	private loadGroup() {
		this.report.GroupID = 0;
		var result = this.reportService.GroupGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GroupList = response;

				if (this.GroupList.length == 0) {
					this.GroupList.unshift({
						GroupID: 0,
						GroupName: "All Groups",
					});
				}

				this.report.GroupID = this.GroupList[0].GroupID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	private loadScanAccessResult() {
		var result = this.reportService.ScanAccessResultGetList();
		result.subscribe(
			(response) => {
				this.ScanAccessResultList = response;

				this.report.ScanAccessResultID = this.ScanAccessResultList[0].ScanAccessResultID;
			},
			(error) => {}
		);
	}

	private loadScanAccessMode() {
		var result = this.reportService.ScanAccessModeGetList();
		result.subscribe(
			(response) => {
				this.ScanAccessModeList = response;

				this.report.ScanAccessModeID = this.ScanAccessModeList[0].ScanAccessModeID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		// if (!this.report.SchoolID) {
		// 	this.errorMessage = "Select the School";
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var result = this.reportService.Print(this.ReportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: UserID
		strParam += this.user.userID + "|UserID";

		//Parameter 2: StartDate
		strParam += "," + moment(this.report.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 3: EndDate
		strParam += "," + moment(this.report.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 4: GradeLevelID
		strParam += "," + this.report.GradeLevelID + "|GradeLevelID";

		//Parameter 5: AcademyID
		strParam += "," + this.report.AcademyID + "|AcademyID";

		//Parameter 6: HomeroomID
		strParam += "," + this.report.HomeroomID + "|HomeroomID";

		//Parameter 7: GroupID
		strParam += "," + this.report.GroupID + "|GroupID";

		//Parameter 8: Active
		strParam += "," + this.report.Active + "|Active";

		//Parameter 9: ScanAccessResultID
		strParam += "," + this.report.ScanAccessResultID + "|ScanAccessResultID";

		//Parameter 10: ScanAccessModeID
		strParam += "," + this.report.ScanAccessModeID + "|ScanAccessModeID";

		//Parameter 11: SortBy
		strParam += "," + this.report.SortBy + "|SortBy";

		//Parameter 12: SortDirection
		strParam += "," + this.report.SortDirection + "|SortDirection";

		//Parameter 13: SchoolID
		strParam += "," + this.report.SchoolID + "|SchoolID";

		//Parameter 14: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
